import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import AccommodationReservation from './AccommodationReservation';

const root = ReactDOM.createRoot(
  document.getElementById('accommodation_reservation')
);

root.render(
  <React.StrictMode>
    <Router>
      <AccommodationReservation />
    </Router>
  </React.StrictMode>
);
